<template>
  <v-dialog width="600" v-model="dialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" small icon color="error">
        <v-icon style="margin-top: -2px">mdi-delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

        <v-btn icon small @click="dialog = !dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text--primary body-1">
        ¿Estás seguro de que deseas eliminar el comentario? Esta acción
        <strong>no se puede deshacer</strong>.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          class="rounded-pill"
          color="primary"
          @click="dialog = !dialog"
        >
          Cancelar
        </v-btn>

        <v-btn
          depressed
          small
          class="rounded-pill"
          color="error"
          @click="deleteObservationComment"
        >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DeleteObservationComment } from "@/graphql/mutations/properties";

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    id: {
      type: Number | String,
      required: true
    }
  },

  methods: {
    deleteObservationComment() {
      this.$apollo
        .mutate({
          mutation: DeleteObservationComment,
          variables: {
            input: {
              id: this.id
            }
          }
        })
        .then(res => {
          this.$emit("reload");
          this.dialog = false;
        });
    }
  }
};
</script>
